module.exports = __webpack_public_path__ + "st.svg?a9db5b501b31b4e456d822975fb8bd7b";